import React from "react";
import Image from "../../components/image";

import SDGLogo from "../../images/online/SDG_Logo_large.png";

const CourseSDG = ({ sDGIcon, containerClass }) => {
  return (
    <div
      className={`mt-3 md:mt-6 px-4 md:px-7 py-9 bg-black-lighter/80 planet:bg-white/10 rounded-xs ${containerClass}`}
    >
      <Image
        imageAlt={"SDG Logo"}
        image={""}
        imageClass={"mb-4 w-5/6 md:w-[45%]"}
        sourceUrl={SDGLogo}
      />
      <div className="flex flex-wrap md:w-full gap-1 text-black-lighter planet:text-white">
        {sDGIcon.map((data, index) => (
          <div
            className="basis-5/12 md:basis-1/4 bg-white/80 planet:bg-white/10 planet:gvi-blur-bg px-3 py-4 rounded-xs"
            key={index}
          >
            <div
              className="h3 planet:font-light"
              dangerouslySetInnerHTML={{ __html: data.name }}
            />
            <div
              className="text-xs font-light"
              dangerouslySetInnerHTML={{ __html: data.desc }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseSDG;
